'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _index = require('./utils/index');

var _mobileViewTypes = require('wix-art-store-3rd-party/dist/src/sdk/mobileViewTypes');

var _mobileViewTypes2 = _interopRequireDefault(_mobileViewTypes);

var _fullscreenCartButton = require('./proGallery/fullscreenCartButton.js');

var _fullscreenCartButton2 = _interopRequireDefault(_fullscreenCartButton);

var _fullscreenCartIcon = require('./proGallery/fullscreenCartIcon.js');

var _fullscreenCartIcon2 = _interopRequireDefault(_fullscreenCartIcon);

var _fullscreenStoreBottomMobileBar = require('./proGallery/fullscreenStoreBottomMobileBar.js');

var _fullscreenStoreBottomMobileBar2 = _interopRequireDefault(_fullscreenStoreBottomMobileBar);

var _fullscreenCheckoutLink = require('./proGallery/fullscreenCheckoutLink.js');

var _fullscreenCheckoutLink2 = _interopRequireDefault(_fullscreenCheckoutLink);

var _index2 = require('./index.js');

var _windowWrapper = require('@wix/photography-client-lib/dist/src/sdk/windowWrapper');

var _windowWrapper2 = _interopRequireDefault(_windowWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var withArtStore = function withArtStore(_ref) {
  var _ref$isOOI = _ref.isOOI,
      isOOI = _ref$isOOI === undefined ? false : _ref$isOOI,
      _ref$viewMode = _ref.viewMode,
      viewMode = _ref$viewMode === undefined ? 'editor' : _ref$viewMode,
      galleryInfo = _ref.galleryInfo,
      wixSdk = _ref.wixSdk,
      storeApi = _ref.storeApi;
  return function (ComposedComponent) {
    var ArtStoreHOC = function (_Component) {
      (0, _inherits3.default)(ArtStoreHOC, _Component);

      function ArtStoreHOC(props) {
        (0, _classCallCheck3.default)(this, ArtStoreHOC);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ArtStoreHOC.__proto__ || (0, _getPrototypeOf2.default)(ArtStoreHOC)).call(this, props));

        _this.state = {
          showMobileShopFrame: false,
          providerView: null
        };
        _this.galleryInfo = galleryInfo;
        _this.connectedProviders = galleryInfo.connectedProviders;
        _this.isMobile = _index.utils.isMobile();
        _this.deviceType = _this.isMobile ? 'mobile' : 'desktop';
        _this.init(_this.connectedProviders);
        _this.toggleMobileShopFrame = _this.toggleMobileShopFrame.bind(_this);
        _this.goToCheckout = _this.goToCheckout.bind(_this);
        _this.onSetMobileData = _this.onSetMobileData.bind(_this);
        return _this;
      }

      (0, _createClass3.default)(ArtStoreHOC, [{
        key: 'init',
        value: function init(connectedProviders) {
          if (connectedProviders) {
            if (!isOOI) {
              storeApi.initCart(this.connectedProviders);
            } else {
              this.pageManager = new _index2.PageManager({
                isMobile: this.isMobile,
                viewMode: this.props.viewMode.toLowerCase(),
                connectedProviders: this.connectedProviders,
                locale: this.props.locale,
                storeApi: storeApi,
                deviceType: this.deviceType
              });
            }
            storeApi.refreshCartItems(connectedProviders);
          }
        }
      }, {
        key: 'calcShopSize',
        value: function calcShopSize(_ref2) {
          var allowTitleExpand = _ref2.allowTitleExpand,
              allowLinkExpand = _ref2.allowLinkExpand,
              allowDescriptionExpand = _ref2.allowDescriptionExpand,
              title = _ref2.title,
              description = _ref2.description,
              link = _ref2.link;

          var size = _windowWrapper2.default.innerHeight - 350;
          size = allowTitleExpand && title ? size - 100 : size;
          size = allowDescriptionExpand && description ? size - 50 : size;
          size = allowLinkExpand && link ? size - 50 : size;
          return size;
        }
      }, {
        key: 'onSetMobileData',
        value: function onSetMobileData(type, data) {
          var providerView = this.state.providerView;

          if (!(providerView && providerView.data && type === 'PRODUCTS_LIST' && providerView.data.length === data.length)) {
            this.setState({ providerView: { type: type, data: data } });
          }
        }
      }, {
        key: 'fullScreenShopElement',
        value: function fullScreenShopElement(props) {
          var _this2 = this;

          var curItem = props.current.item;
          if (!['image', 'picture'].includes(curItem.type)) {
            return false;
          }
          var _galleryInfo = this.galleryInfo,
              styleId = _galleryInfo.styleId,
              pageId = _galleryInfo.pageId,
              galleryId = _galleryInfo.galleryId;

          var isMobile = this.isMobile;
          var shopContainerStyle = {};
          !isMobile && (shopContainerStyle.maxHeight = this.calcShopSize((0, _extends3.default)({}, props.styleParams, curItem)));
          isMobile && !props.isAdditionalMobileSidebarOpened && (shopContainerStyle.visibility = 'hidden');
          var openShopEditor = function openShopEditor(editorData) {
            _this2.pageManager.shopEditorData = editorData;
            _this2.props.changeStoreFrameState(_index2.ARTSTORE_PUBSUB_ENUMS.EDITOR, true);
          };
          var shopContainerClassName = 'fullscreen-shop-container ' + (isMobile ? 'mobile' : '');
          var shopButtonsClassName = 'fullscreen-shop-buttons ' + (isMobile ? 'mobile' : '');
          return _react2.default.createElement(
            'div',
            { style: { height: '100%' } },
            _react2.default.createElement(
              'div',
              { className: shopContainerClassName, style: shopContainerStyle },
              _react2.default.createElement(_index2.FullScreenShop, {
                wixSdk: wixSdk,
                storeApi: storeApi,
                cartItemsData: this.props.cartItemsData,
                ref: function ref(element) {
                  return _this2.shopElement = element;
                },
                item: curItem,
                styleParams: props.styleParams,
                isOOI: isOOI,
                styleId: styleId,
                additionalProviderParams: this.props.additionalProviderParams,
                toggleShopEditorPage: openShopEditor,
                toggleMobileShopFrame: this.toggleMobileShopFrame,
                pageId: pageId,
                isMobile: isMobile,
                locale: props.locale,
                deviceType: this.deviceType,
                viewMode: viewMode,
                onSetMobileData: this.onSetMobileData,
                connectedProviders: this.connectedProviders,
                galleryId: galleryId
              })
            ),
            _react2.default.createElement(
              'div',
              { className: shopButtonsClassName },
              this.getShopButtons()
            )
          );
        }
      }, {
        key: 'fullscreenCartIcon',
        value: function fullscreenCartIcon() {
          var _this3 = this;

          return _react2.default.createElement(_fullscreenCartIcon2.default, {
            showCart: function showCart() {
              return _this3.showCart();
            },
            cartItemsCount: this.getCartItemsCount() });
        }
      }, {
        key: 'showCart',
        value: function showCart() {
          isOOI ? this.props.changeStoreFrameState(_index2.ARTSTORE_PUBSUB_ENUMS.CART, true) : storeApi.showCart();
        }
      }, {
        key: 'getCartItemsCount',
        value: function getCartItemsCount() {
          var _props = this.props,
              cartItemsData = _props.cartItemsData,
              cartItemsCount = _props.cartItemsCount;

          var count = cartItemsData && cartItemsData.cartItemsCount;
          return count || cartItemsCount || 0;
        }
      }, {
        key: 'getShopButtons',
        value: function getShopButtons() {
          var _this4 = this;

          var _state = this.state,
              providerView = _state.providerView,
              showMobileShopFrame = _state.showMobileShopFrame;

          var showAddToCart = providerView && providerView.type === _mobileViewTypes2.default.singleProduct;
          var isMobile = this.isMobile;
          var showCheckoutLink = !isMobile || !showMobileShopFrame;
          var addToCartRequest = function addToCartRequest() {
            _this4.closeMobileShopFrameIfOpen();
            _this4.shopElement.addToCartRequest();
          };
          return _react2.default.createElement(
            'div',
            null,
            showAddToCart ? _react2.default.createElement(_fullscreenCartButton2.default, {
              cartItemsCount: this.getCartItemsCount(),
              mobileShopFrameOpen: !!(isMobile && showMobileShopFrame),
              onAddToCartRequest: addToCartRequest,
              styleParams: this.props.styles
            }) : null,
            showCheckoutLink ? _react2.default.createElement(_fullscreenCheckoutLink2.default, {
              cartItemsCount: this.getCartItemsCount(),
              onClick: this.goToCheckout
            }) : null
          );
        }
      }, {
        key: 'closeMobileShopFrameIfOpen',
        value: function closeMobileShopFrameIfOpen() {
          this.isMobile && this.state.showMobileShopFrame && this.toggleMobileShopFrame();
        }
      }, {
        key: 'toggleMobileShopFrame',
        value: function toggleMobileShopFrame() {
          if (this.isMobile) {
            this.setState({
              showMobileShopFrame: !this.state.showMobileShopFrame
            });
          }
        }
      }, {
        key: 'fullScreenMobileShopElement',
        value: function fullScreenMobileShopElement(props) {
          var _this5 = this;

          var item = props.item || props.itm;
          var actions = (0, _extends3.default)({}, props.actions, { toggleMobileShopFrame: this.toggleMobileShopFrame });
          return item ? _react2.default.createElement(_fullscreenStoreBottomMobileBar2.default, {
            current: props.current,
            item: item,
            styleParams: props.styleParams,
            actions: actions,
            showShopFrame: true,
            showMobileShopFrame: this.state.showMobileShopFrame,
            showShareScreen: props.showShareScreen,
            galleryId: galleryInfo.galleryId,
            onClick: this.goToCheckout,
            providerView: this.state.providerView,
            onAddToCartRequest: function onAddToCartRequest() {
              return _this5.shopElement && _this5.shopElement.addToCartRequest();
            },
            onProviderAction: function onProviderAction(type, data) {
              return _this5.shopElement && _this5.shopElement.postShopRequest(type, data);
            },
            cartItemsCount: this.getCartItemsCount()
          }) : false;
        }
      }, {
        key: 'getFullscreenPage',
        value: function getFullscreenPage() {
          var _this6 = this;

          var customMobileSidebarRenderer = this.isMobile ? function (props) {
            return _this6.fullScreenMobileShopElement(props);
          } : false;
          return _react2.default.createElement(ComposedComponent, (0, _extends3.default)({}, this.props, {
            viewMode: viewMode,
            additionalSidebarElement: function additionalSidebarElement(props) {
              return _this6.fullScreenShopElement(props);
            },
            isAdditionalMobileSidebarOpened: this.state.showMobileShopFrame,
            additionalNavbarElement: function additionalNavbarElement() {
              return _this6.fullscreenCartIcon();
            },
            customMobileSidebarRenderer: customMobileSidebarRenderer
          }));
        }
      }, {
        key: 'goToCheckout',
        value: function goToCheckout() {
          this.closeMobileShopFrameIfOpen();
          isOOI ? this.pageManager.goToCheckout() : storeApi.onCheckout();
        }
      }, {
        key: 'getPagesData',
        value: function getPagesData() {
          var _props$props$host = (0, _extends3.default)({}, this.props, this.props.host),
              cartItemsData = _props$props$host.cartItemsData,
              additionalProviderParams = _props$props$host.additionalProviderParams,
              checkoutParams = _props$props$host.checkoutParams,
              changeStoreFrameState = _props$props$host.changeStoreFrameState;

          return (0, _extends3.default)({}, cartItemsData, {
            additionalProviderParams: additionalProviderParams,
            wixSdk: wixSdk,
            changeStoreFrameState: changeStoreFrameState,
            checkoutParams: checkoutParams,
            storeApi: storeApi
          });
        }
      }, {
        key: 'render',
        value: function render() {
          if (!isOOI) {
            return this.getFullscreenPage();
          }
          var _props2 = this.props,
              fullscreenIdx = _props2.fullscreenIdx,
              pagesState = _props2.pagesState;

          var fullscreenPage = fullscreenIdx >= 0 ? this.getFullscreenPage() : null;
          var artStorePages = this.pageManager.getPages(this.getPagesData(), pagesState, 'gallery');
          return _react2.default.createElement(
            'span',
            null,
            fullscreenPage,
            artStorePages
          );
        }
      }]);
      return ArtStoreHOC;
    }(_react.Component);

    return ArtStoreHOC;
  };
};

exports.default = withArtStore;